// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronRight24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronRight24: FC<ChevronRight24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m10.343 19.2-1.486-1.208L13.76 12 8.857 6.008 10.343 4.8 16.24 12l-5.897 7.2Z" />
        </svg>
    );
};

export default ChevronRight24;
